import { ColumnDef } from '@tanstack/react-table';
import { ActionDropdown } from './ActionDropdown';
import { ProfileListItem } from '../types';
import { Hospital } from 'lucide-react';
import { formatDate, getProfileColor } from '@/utils';
import { SortableHeader, TruncatedCell } from '@/components';

export const columns: ColumnDef<ProfileListItem>[] = [
  {
    header: ({ column }) => (
      <SortableHeader column={column}>Profile</SortableHeader>
    ),
    accessorKey: 'displayName',
    enableSorting: true,
    cell: ({ row }) => {
      const name = row.original.displayName;
      const color = getProfileColor(row.original.avatarType);
      return (
        <div className="flex items-center gap-2">
          <Hospital className="h-4 w-4 shrink-0" style={{ color }} />
          <TruncatedCell text={name} />
        </div>
      );
    },
  },
  {
    header: 'Description',
    accessorKey: 'description',
    cell: ({ row }) => {
      const description = row.original.description;
      return description ? <TruncatedCell text={description} /> : null;
    },
  },
  {
    header: ({ column }) => (
      <SortableHeader column={column}>Date Created</SortableHeader>
    ),
    accessorKey: 'createdAt',
    enableSorting: true,
    cell: ({ row }) => formatDate(row.original.createdAt),
  },
  {
    header: 'Actions',
    accessorKey: 'actions',
    cell: ({ row }) => {
      return <ActionDropdown profile={row.original} />;
    },
  },
];
